import React, { useMemo } from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';
const TextureImage = React.memo(({ imageSrc, width, height, mask }) => {
    const [canvasImage] = useImage(imageSrc, 'anonymous');
    const cachedImage = useMemo(() => canvasImage, [canvasImage]);
    if (!imageSrc) {
        return null;
    }
    return (React.createElement(Image, { width: width, height: height, x: 0, y: 0, image: cachedImage, fill: "transparent", globalCompositeOperation: mask, listening: false }));
});
export default TextureImage;
